import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { InboxPage } from "#/pages/inbox";

const inboxSearchSchema = z.object({
  // ?conversation= 这种空值要当作没选中，而不是让整页崩掉。
  conversation: z.string().min(1).optional().catch(undefined),
});

export const Route = createFileRoute("/_console/inbox")({
  component: InboxRoute,
  validateSearch: inboxSearchSchema,
});

/** 选中的会话是路由状态：刷新和前进后退都要能回到同一条（PRD 4.1）。 */
function InboxRoute() {
  const { conversation } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <InboxPage
      onSelectConversation={(conversationId) => {
        void navigate({ search: { conversation: conversationId } });
      }}
      selectedConversationId={conversation}
    />
  );
}
